module.exports = __webpack_public_path__ + "static/media/antique_elegance_banner.c373e047.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/antique_elegance_banner.png
// module id = 504
// module chunks = 0